import React from 'react';
import { Heading } from '../../common/form/form-parts';
import { Trans, useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { SelectCountry } from '../../common/form/select-country';
import { getAvailableUserRegistrationCountries } from '../../../helpers/get-available-user-registration-countries';
import { SwedenCountryCode } from 'tradera/apps/registration/components/common/form/form-header';
import { Input, InputCheckbox } from './form-input';
import { useFormContext } from 'react-hook-form';

export const SwedishCompanyFormEmail = ({
    serverErrors,
    rules,
    onNavigate
}) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const availableCountries = getAvailableUserRegistrationCountries(t);
    const { trigger } = useFormContext();

    return (
        <>
            <Heading>{t('registration_company_sign_up_heading')}</Heading>
            <p className="mb-3 text-center">
                {t('registration_welcome_text')}
                <br />
                {t('registration_select_country')}
            </p>
            <SelectCountry
                availableCountries={availableCountries}
                onCountrySelected={(selectedValue) => {
                    window.location.href = `${toLocalizedUrl(
                        '/register/foreign-company'
                    )}?countryCode=${selectedValue}`;
                }}
                selectedCountryCodeIso2={SwedenCountryCode}
                className="mb-3"
            />
            <Input
                name="emailAddress"
                type="email"
                label={t('registration_placeholder_email')}
                rules={rules}
                serverErrors={serverErrors}
                className="mb-3"
            />

            <InputCheckbox
                name="emailTerms"
                type="checkbox"
                rules={rules}
                serverErrors={serverErrors}
                className="mb-2">
                <Trans
                    i18nKey="registration_company_account_policy_Trans"
                    components={{
                        a: (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/anchor-has-content
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link"
                            />
                        )
                    }}
                />
            </InputCheckbox>
            <div>
                <button
                    type="button"
                    className="btn btn-primary btn-fluid mt-1"
                    onClick={async () => {
                        if (await trigger()) {
                            onNavigate();
                        }
                    }}>
                    {t('registration_continue_button')}
                </button>
            </div>
        </>
    );
};
